<!-- 首页 -->
<!--  -->
<template>
  <div>
    <div class="red bg"
         @click="messageHandle">点击 </div>
    <div @click="modalHandle">弹窗</div>
    <div class="type">cs</div>
    <div>cs</div>
    <zlr-modal v-model="isShow"
               width="200px"
               :mask-closable=false>
      <div class="red">
        你好
      </div>
    </zlr-modal>
    <editor ref="analysisEditor"
            :cache=false />
    <Button type="primary">提交</Button>
    <div>
      <upload></upload>
    </div>
    <zlr-card-service title="申请信息申请信息申请"
                      style="width: 400px;"
                      kind="CV"
                      kind-color="#FFADD2"
                      explain="请填写教育背景和考试分数，以便导师更了解你"
                      circle="warning">
      <div>教育背景和考试分数</div>
    </zlr-card-service>
  </div>
</template>

<script>
import ZlrModal from '_c/modal/modal'
import Editor from '_c/editor/editor'
import Upload from '_c/upload/upload'
import ZlrCardService from '_c/card-service/card-service'
export default {
  name: 'c',
  components: {
    ZlrModal,
    Editor,
    Upload,
    ZlrCardService
  },
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    this.$refs['analysisEditor'].setHtml('<a>2232313</a>')
  },
  methods: {
    messageHandle () {
      this.$zlr_message('上传成功', 'success')
    },
    modalHandle () {
      this.isShow = true
    }
  }
}
</script>
